import { Reveal } from "./Reveal";

export default function PageHero({ eyebrow, title, lead }) {
  return (
    <section className="bg-coal border-b border-line bg-grid">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <Reveal>
          <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-gold flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-gold" aria-hidden="true" />
            {eyebrow}
          </p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold uppercase tracking-tight text-slate-100 mt-4 max-w-3xl leading-[1.05]">
            {title}
          </h1>
          {lead ? <p className="text-slate-400 mt-5 max-w-2xl leading-relaxed">{lead}</p> : null}
        </Reveal>
      </div>
    </section>
  );
}
